import React from 'react';

import styles from './PromoNotification.module.scss';

const PromoNotification = ({ icon, text, onClose, isHighlighted = false }) => (
    <div className={`${styles.wrapper} ${isHighlighted ? styles.highlighted : ''}`}>
        <div className={styles.message}>
            <img className={styles.icon} src={icon} alt={''} />
            <div className={styles.text}>{text}</div>
        </div>
        {onClose &&
            <div className={styles.closeBtn} onClick={onClose}>
                <div className={styles.container}>
                    <div className={styles.bar1}></div>
                    <div className={styles.bar2}></div>
                </div>
            </div>
        }
    </div>
);

export default PromoNotification;
